<template>
  <div id="app" ref="wrapper">
    <keep-alive>
   		<router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
  // import BScroll from 'better-scroll';
  export default {
  name: 'App',
    // mounted() {
    //   this.$nextTick(() => {
    //     this.scroll = new BScroll(this.$refs.wrapper, {
    //       scrollY: true,
    //       click: true,
    //       bounce: false
    //     })
    //   })
    // }
};
</script>




// WEBPACK FOOTER //
// src/App.vue